import type { CitationDetails } from "@elation/api-client/src/stitch-api";
// import { useGetPatientCitations } from "@elation/api-client/src/stitch-api";
// import { useCurrentPatient } from "@src/stores/app";
import React from "react";

interface CitationsProviderProps {
  children: React.ReactNode;
}

interface CitationsProviderContextType {
  citations: CitationDetails[];
  citationsByMarker: Record<number, CitationDetails>;
}

const CitationsProviderContext =
  React.createContext<CitationsProviderContextType | null>(null);

export const CitationsProvider = ({ children }: CitationsProviderProps) => {
  // TODO: wire up to stitch-web citations endpoint when available
  // const currentPatient = useCurrentPatient();
  //
  // const { data: citationsData } = useGetPatientCitations(
  //   currentPatient?.id ?? -1,
  //   {
  //     query: {
  //       enabled: !!currentPatient?.id,
  //     },
  //   },
  // );
  //
  // const citationsByMarker =
  //   citationsData?.data?.reduce(
  //     (acc, citation) => {
  //       acc[citation.marker] = citation;
  //       return acc;
  //     },
  //     {} as Record<number, CitationDetails>,
  //   ) ?? {};
  //
  // return (
  //   <CitationsProviderContext.Provider
  //     value={{ citations: citationsData?.data ?? [], citationsByMarker }}
  //   >
  //     {children}
  //   </CitationsProviderContext.Provider>
  // );

  return (
    <CitationsProviderContext.Provider
      value={{ citations: [], citationsByMarker: {} }}
    >
      {children}
    </CitationsProviderContext.Provider>
  );
};

export const usePatientCitations = () => {
  const context = React.useContext(CitationsProviderContext);

  if (context === null) {
    return { citations: [], citationsByMarker: {} };
  }

  return context;
};
